import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";

const fallbackBaseUrl = () =>
    process.env.REACT_APP_API_BASE_URL || "https://alny.shiftcms.net/api/v1";
const fallbackAuthHeaders = () => {
    const token = Cookies.get("token");
    const apiKey = process.env.REACT_APP_API_KEY;
    return {
        Authorization: `Bearer ${token}`,
        apiKey: apiKey,
        "Content-Type": "application/json",
    };
};

export interface TelegramLog {
    id: number;
    user_id: number | null;
    user: {
        id: number;
        name: string;
        surname: string;
        email: string;
        telegram_id: string | null;
    } | null;
    chat_id: number;
    bot_key: string | null;
    message: string;
    status: number;
    error_code: number | null;
    description: string | null;
    created_at: string;
}

export interface TelegramLogsApiParams {
    user_id?: number;
    chat_id?: number;
    status?: number;
    error_code?: number;
    date_from?: string;
    date_to?: string;
    per_page?: number;
    page?: number;
    sort_by?: "id" | "created_at" | "status" | "error_code";
    sort_order?: "asc" | "desc";
}

export interface TelegramLogsApiResponse {
    success: boolean;
    data: TelegramLog[];
    meta: {
        current_page: number;
        per_page: number;
        total: number;
        last_page: number;
    };
}

export const useTelegramLogs = (params: TelegramLogsApiParams = {}) => {
    return useQuery({
        queryKey: ["telegramLogs", params],
        queryFn: async (): Promise<TelegramLogsApiResponse> => {
            const searchParams = new URLSearchParams();

            if (params.user_id) searchParams.append("user_id", params.user_id.toString());
            if (params.chat_id) searchParams.append("chat_id", params.chat_id.toString());
            if (params.status !== undefined) searchParams.append("status", params.status.toString());
            if (params.error_code !== undefined) searchParams.append("error_code", params.error_code.toString());
            if (params.date_from) searchParams.append("date_from", params.date_from);
            if (params.date_to) searchParams.append("date_to", params.date_to);
            if (params.per_page) searchParams.append("per_page", params.per_page.toString());
            if (params.page) searchParams.append("page", params.page.toString());
            if (params.sort_by) searchParams.append("sort_by", params.sort_by);
            if (params.sort_order) searchParams.append("sort_order", params.sort_order);

            const response = await axios.get(
                `${fallbackBaseUrl()}/admin/telegram-logs?${searchParams.toString()}`,
                {
                    headers: fallbackAuthHeaders(),
                }
            );

            return response.data;
        },
    });
};

export const exportTelegramLogs = async (params: TelegramLogsApiParams = {}) => {
    const searchParams = new URLSearchParams();

    if (params.user_id) searchParams.append("user_id", params.user_id.toString());
    if (params.chat_id) searchParams.append("chat_id", params.chat_id.toString());
    if (params.status !== undefined) searchParams.append("status", params.status.toString());
    if (params.error_code !== undefined) searchParams.append("error_code", params.error_code.toString());
    if (params.date_from) searchParams.append("date_from", params.date_from);
    if (params.date_to) searchParams.append("date_to", params.date_to);
    if (params.sort_by) searchParams.append("sort_by", params.sort_by);
    if (params.sort_order) searchParams.append("sort_order", params.sort_order);

    const response = await axios.get(
        `${fallbackBaseUrl()}/admin/telegram-logs/export?${searchParams.toString()}`,
        {
            headers: fallbackAuthHeaders(),
        }
    );

    return response.data;
};
